import React, { useState, useEffect, useContext } from 'react';
import './CaletasSelected.scss';
import woman from '../AssetsCaleta/icon-man.svg'
import man from '../AssetsCaleta/icon-woman.svg'
import { Doughnut } from 'react-chartjs-2';
import { ResourcesContext } from '../../ContextProvider';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
/**
 * Componente de la Caleta Seleccionada
 * Muestra los datos estadísticos de la caleta seleccionada
 */
const CaletaSelected = ({caleta, region, id}) => {
    const resources = useContext(ResourcesContext)
    const [organizations, setOrganizations] = useState([]);
    const [desembarque, setDesembarque] = useState([]);
    const [species, setSpecies] = useState([]);
    const [specieSelected, setSpecieSelected] = useState();

    const [tab, setTab] = useState(0);
    let data = {
        datasets: [
            {
                data: [caleta.nroMujeres, caleta.nroHombres],
                backgroundColor: ["#3cb371", "#29abe2"]
            }
        ]
    }
    function toTitleCase(str) {
        if (str) {
            return str.replace(
                /\w\S*/g,
                function (txt) {
                    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
                }
            );
        }
    }
    function cutDecimals(number, decimals) {
        return (Math.round(number * 100) / 100).toFixed(2);
    }

    function getDesembarquePeriodo() {
        resources.getDesembarquesPeriodos(region, null, id, null).then((r) => {
            setDesembarque(r.data !== null ? r.data : []);
        }).then((err) => {
            console.warn(err)
        })
    }
    function getData() {
        resources.getOrganizations(region, null, id).then((result) => {
            setOrganizations(result.data !== null ? result.data : []);
        }).then((err) => {
            console.warn(err)
        })
    }
    function exportToCsv(csvData, fileName = caleta.nombreCaleta) {
        let headers = [{ 'Nombre de especie': '' }, { 'Ultimos 6 mes': '' }, { 'Ultimo mes': '' }]
        let _data = [];
        desembarque.map((item) => {
            let _item1 = { 'Nombre de especie': item.nombreEspecie, 'Ultimo 6 mes': item.desembarque_6m, 'Ultimo mes': item.desembarque_1m }
            _data.push(_item1)
        })
        const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        const fileExtension = '.xlsx';

        const ws = XLSX.utils.json_to_sheet(_data, { header: ["Nombre de especie", "Ultimo 6 mes", 'Ultimo mes'] });
        const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(data, fileName + fileExtension);
    }

    const getEspecies = () => {
        resources.getEspeciesByIfop(region, 0, 0).then((result) => {
            setSpecies(result);
            setSpecieSelected(result[0]);
        }).catch((err) => {
            console.warn({ getEspeciesByIfobError: err });
        });
    }
    useEffect(() => {
        getData();
        getEspecies();
        getDesembarquePeriodo();
    }, [caleta, region, id])
    return (
        <div className="caletasSelectedMainContainer">
            {
                caleta && (
                    <div className="chartOne">
                        <span className="chartTitle">
                            NÚMERO DE PESCADORES: {caleta.nroPescadores}
                        </span>

                        <div className="chartContainer">
                            <div className="dataContainer dataContainerLeft">
                                <img src={woman} alt="" />
                                <div className="itemData">
                                    <span className="labelContent">{caleta.nroMujeres}</span>
                                    <span className="label">Mujeres</span>
                                </div>
                            </div>

                            <div className="chartContainer">
                                <Doughnut
                                    data={data}
                                    options={{ showLines: false, rotation: (-0.7 * Math.PI) - (25 / 180 * Math.PI), maintainAspectRatio: false }} >
                                </Doughnut>
                            </div>

                            <div className="dataContainer dataContainerRight">
                                <img src={man} alt="" />
                                <div className="itemData">
                                    <span className="labelContent">{caleta.nroHombres}</span>
                                    <span className="label">Hombres</span>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }

            <div className="tabs">
                <div onClick={() => { setTab(0) }} className={(tab === 0 ? 'selected' : "unselected") + ' tab'} >Número de áreas de manejo</div>
                <div onClick={() => { setTab(1) }} className={(tab === 1 ? 'selected' : "unselected") + ' tab'} >Acuicultura de pequeña escala</div>
                <div onClick={() => { setTab(2) }} className={(tab === 2 ? 'selected' : "unselected") + ' tab'} >Número de organizaciones</div>
            </div>



            {
                tab === 0 && (
                    <div className="titleAndChartContainer">
                        <div className="item">
                            <div className="title">
                                <span> Número de Áreas  de  Manejo </span>
                            </div>
                            <div className="text">
                                <span>
                                    Las áreas de manejo son porciones de mar que se entregan a organizaciones de pescadores, para el cuidado y manejo de los recursos de manera sustentable
                                </span>
                            </div>
                        </div>
                        <div className="chart">
                            <div className="donut">
                                <span>
                                    <span> {caleta.nroAreasManejo ? caleta.nroAreasManejo : 0}</span>
                                </span>
                            </div>
                        </div>
                    </div>
                )
            }

            {
                tab === 1 && (
                    <div className="titleAndChartContainer">
                        <div className="item">
                            <div className="title">
                                <span> Acuicultura de pequeña escala </span>
                            </div>
                            <div className="text">
                                <span>
                                Iniciativas de cultivo de especies, llevadas a cabo por Organizaciones de Pescadores Artesanales o pequeñas empresas.
                                </span>
                            </div>
                        </div>
                        <div className="chart">
                            <div className="donut">
                                <span>
                                    <span> {caleta.nroAreasAPE ? caleta.nroAreasAPE : 0}</span>
                                </span>
                            </div>
                        </div>
                    </div>
                )
            }

            {
                tab === 2 && (
                    <div className="tableContainer">
                        {
                            organizations.map((o, idx) => {
                                return (
                                    <div key={o.nombreOrganizacion} className="item">
                                        <span className="number">{idx + 1}</span>
                                        <span className="text">{toTitleCase(o.nombreOrganizacion)}</span>
                                    </div>
                                )
                            })
                        }
                    </div>
                )
            }

            <div className="block_speciesMarinasTitle">
                NUESTROS RECURSOS
            </div>

            <div onClick={() => { window.open("https://www.ifop.cl/wp-content/contenidos/uploads/mi_guia_de_especies_marinas.pdf", "_blank"); }} className="block_speciesMarinasPDF">
                <span>Descarga aqui la Guia de especies marinas chilenas</span>
            </div>

            <div className="tableContainer">
                <h1>Toneladas de extracción de nuestros recursos</h1>
                <div className="headers">
                    <div className="item">Nombre de recurso</div>
                    <div className="item">Últimos 6 meses</div>
                    <div className="item">Último mes</div>
                </div>
                <div className="table-data">
                    {
                        desembarque.length > 0 ? desembarque.map((r, idx) => {
                            if (r.desembarque_1m) { r.desembarque_1m = cutDecimals(r.desembarque_1m, 3); }
                            if (r.desembarque_6m) { r.desembarque_6m = cutDecimals(r.desembarque_6m, 3) }
                            return (
                                <div className="row" key={idx}>
                                    <div className="col center" >{toTitleCase(r.nombreEspecie)}</div>
                                    <div className="col center" >{(r.desembarque_6m ? r.desembarque_6m : '--')}</div>
                                    <div className="col center" >{(r.desembarque_1m ? r.desembarque_1m : '--')}</div>
                                </div>
                            )
                        }) : <div className="row">
                                <div className="col center" >Actualmente sin datos</div>
                                <div className="col center" >---</div>
                                <div className="col center" >---</div>
                            </div>
                    }
                </div>
                
                {desembarque.length > 0 && <div className="exportDataBtn">
                    <div className="btn" onClick={() => { exportToCsv() }}>Descarga esta información aquí</div>
                </div>}
            </div>


        </div>
    )
}

export default CaletaSelected;